/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-07-22",
    versionChannel: "nightly",
    buildDate: "2023-07-22T00:19:38.712Z",
    commitHash: "77c0dac64be338500e8dbba1d8ad37d13a10cb5b",
};
